<nav #header class="fixed-top" style="background-color: white !important; filter: drop-shadow(1px 1px 1px #6666664d);">
    <div class="containerHeader">
        <div>
            <a href="https://www.galapagosluxurycruise.com" target="_blank"><img
                    src="../assets/images/logos-header/glc.svg" class="" alt=""
                    style="width: 207px;" decoding="async"></a>
        </div>
        <div class="kontakt">
            <ul class="navbar-nav">
                <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/" target="_blank">HOME</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/cruises/catamarans-2"
                        target="_blank">CRUISES<i class="fa fa-caret-down" style="padding-left: 5px;"></i></a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/charters"
                        target="_blank">CHARTERS</a>
                </li>
                <li class="nav-item menuItem"><a
                        href="https://www.galapagosluxurycruise.com/tours/hotel-based-galapagos" target="_blank">TOURS<i
                            class="fa fa-caret-down" style="padding-left: 5px;"></i></a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/about-galapagos"
                        target="_blank">GALAPAGOS</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/about-us"
                        target="_blank">ABOUT
                        US</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/inquire-here"
                        target="_blank">INQUIRE</a>
                </li>
                <li class="nav-item menuItem" *ngIf="companyParamsService.getFiltersInterest()">
                    <app-heart-header></app-heart-header>
                </li>
            </ul>
            <div class="header-telephone">
                <a href="tel:18132007862" title="Tel. 1-813-200-7862"
                    style="color: black !important; padding-right: 10px; border-right: 1px solid ;" target="_blank"><i
                        class="fa fa-phone"></i>
                    1-813-200-7862</a>
                <a href="https://wa.me/593968851289?text=Hi%20GalapagosLuxuryCruise.com!%20I%20have%20a%20question."
                    title="contact-us" target="_blank">
                    <i class="fa fa-whatsapp" style="color: #28a745!important; font-size: 24px !important;"></i></a>
            </div>
        </div>
        <a class="menuButton" (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
    </div>
    <ul class="navbar-nav verticalMenu" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/" target="_blank">HOME</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/cruises/catamarans-2"
                target="_blank">CRUISES</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/charters"
                target="_blank">CHARTERS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/tours/hotel-based-galapagos"
                target="_blank">TOURS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/about-galapagos"
                target="_blank">GALAPAGOS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/about-us" target="_blank">ABOUT
                US</a>
        </li>
        <li class="nav-item menuItem"><a href="https://www.galapagosluxurycruise.com/inquire-here"
                target="_blank">INQUIRE</a>
        </li>
        <li class="nav-item menuItem" style="display: flex; flex-direction: row; gap: 30px; background-color: #d9cfa8;">
            <a href="tel:18132007862" title="Tel. 1-813-200-7862" target="_blank"
                style="font-size: 18px; border-right: 1px solid ;padding-right: 10px;  color: black !important;"><i
                    class="fa fa-phone" style=" color: black;"></i>
                1-813-200-7862</a>
            <a href="https://wa.me/593968851289?text=Hi%20GalapagosLuxuryCruise.com!%20I%20have%20a%20question."
                title="contact-us" target="_blank">
                <i class="fa fa-whatsapp" style="color: #28a745!important; font-size: 26px;"></i></a>
        </li>
        <li class="nav-item menuItem" *ngIf="companyParamsService.getFiltersInterest()">
            <app-heart-header></app-heart-header>
        </li>
    </ul>
</nav>